import {
  Activity,
  Archive,
  Boxes,
  Cpu,
  Database,
  HardDrive,
  Server,
  Trash2,
} from 'lucide-react'

export function SystemPlugin() {
  return (
    <section className="module-card">
      <header>
        <div>
          <strong>
            Sistema / VPS
          </strong>

          <span>
            Infraestructura
          </span>
        </div>

        <Server size={18} />
      </header>

      <div className="system-health">
        <Activity size={15} />

        Esperando telemetría real
      </div>

      <div className="system-menu system-button-grid">
        <button type="button" data-system-action="true">
          <Cpu size={15} />
          Recursos
        </button>

        <button type="button" data-system-action="true">
          <Boxes size={15} />
          Servicios
        </button>

        <button type="button" data-system-action="true">
          <Database size={15} />
          Software
        </button>

        <button type="button" data-system-action="true">
          <HardDrive size={15} />
          Almacenamiento
        </button>

        <button type="button" data-system-action="true">
          <Archive size={15} />
          Backups
        </button>

        <button type="button" data-system-action="true">
          <Trash2 size={15} />
          Mantenimiento
        </button>
      </div>

      <div className="backup-policy">
        Drive verificado →
        conservar 3 en VPS
      </div>

      <div className="vps-payment">
        <span>
          Próximo pago VPS
        </span>

        <strong>
          Sin configurar
        </strong>
      </div>
    </section>
  )
}
